module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "asideNav_msg"
    }
  }, [_c('div', {
    staticClass: "asideNav_button"
  }, [_c('el-button', {
    staticClass: "button_msg",
    attrs: {
      "round": "",
      "circle": "",
      "icon": "el-icon-bell"
    },
    on: {
      "click": function($event) {
        _vm.isShowMessage = !_vm.isShowMessage
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowDot),
      expression: "isShowDot"
    }],
    staticClass: "dot_msg"
  })], 1), _vm._v(" "), _c('transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowMessage),
      expression: "isShowMessage"
    }],
    staticClass: "asideNav_main"
  }, [_vm._t("default")], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-049c3c48","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/message/asideNav.vue
// module id = 518
// module chunks = 1 2 3 4 5 6 7 8